import { render, staticRenderFns } from "./RelatorioFaturaReceita.vue?vue&type=template&id=40d3715a"
import script from "./RelatorioFaturaReceita.vue?vue&type=script&lang=js"
export * from "./RelatorioFaturaReceita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports